import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import { has } from 'lodash';
import api from '@/services/utils/base';
import MenuBase from '@/views/layout/navigation/menu-base.ts';
import BillingApi from '@/services/rest/bemob/billing';
import CampaignApi from '@/services/rest/bemob/campaign';

@Component
export default class MenuReportDialogsMixin extends mixins<MenuBase>(MenuBase) {
  billingApi: BillingApi = new BillingApi();
  campaignApi: CampaignApi = new CampaignApi();
  createCampaign() {
    this.bus.emit('open-dialog', { name: 'CreateCampaign', data: { isCreate: true } });
  }

  editCampaign(id?: string) {
    this.bus.emit('open-dialog', { name: 'EditCampaign', data: { id } });
  }

  duplicateCampaign(id?: string) {
    this.bus.emit('open-dialog', { name: 'DuplicateCampaign', data: { id } });
  }

  bulkEditCampaigns() {
    this.bus.emit('open-dialog', { name: 'BulkEditCampaign' });
  }

  updateCost() {
    this.bus.emit('open-dialog', { name: 'UpdateCost' });
  }

  campaignLinks(id?: string) {
    this.bus.emit('open-dialog', { name: 'CampaignLinks', data: { id } });
  }
  
  startStop({ id, buttonText }) {
    const status = ()=>{
      if(buttonText===this.t('Start')){return 'play'}
      if(buttonText===this.t('Stop')){return 'stop'}
    }
    
    const successMessage = ()=>{
      if(buttonText===this.t('Start')){return 'Campaign successfully started'}
      if(buttonText===this.t('Stop')){return 'Campaign successfully stopped'}
    }
    
    return this.campaignApi.putExternalStatus(id,{
      status:status()
    }).then((payload)=>{
      this.bus.emit('update-report-row', {
        id,
        data:[
          { 
            newData:payload.data.payload?.externalStatus,
            column:'DT_RowCampaignExternalStatus'
          },
          { 
            newData:payload.data.payload?.externalStatus,
            column:'DT_RowCampaignExternalStatus'
          }
        ]
      });

      this.$store.commit('tableSelectedItems', null);
      this.bus.emit('toast-success', successMessage());
    })
    .catch((error) => Promise.reject(error))
  }

  createOffer() {
    this.bus.emit('open-dialog', { name: 'CreateOffer' });
  }

  editOffer(id?: string) {
    this.bus.emit('open-dialog', { name: 'EditOffer', data: { id } });
  }

  duplicateOffer() {
    this.bus.emit('open-dialog', { name: 'DuplicateOffer' });
  }

  bulkEditOffer() {
    this.bus.emit('open-dialog', { name: 'BulkEditOffer' });
  }

  createLanding() {
    this.bus.emit('open-dialog', { name: 'CreateLanding' });
  }

  editLanding(id?: string) {
    this.bus.emit('open-dialog', { name: 'EditLanding', data: { id } });
  }

  bulkEditLanding() {
    this.bus.emit('open-dialog', { name: 'BulkEditLanding' });
  }

  duplicateLanding() {
    this.bus.emit('open-dialog', { name: 'DuplicateLanding' });
  }

  createFlow() {
      this.bus.emit('open-dialog', { name: 'CreateFlow' });
  }

  editFlow(id?: string) {
      this.bus.emit('open-dialog', { name: 'EditFlow', data: { id } });
  }

  duplicateFlow() {
    this.bus.emit('open-dialog', { name: 'DuplicateFlow' });
  }

  createAffiliateNetwork() {
    this.bus.emit('open-dialog', { name: 'CreateAffiliateNetworks' });
  }

  editAffiliateNetwork(id?: string) {
    this.bus.emit('open-dialog', { name: 'EditAffiliateNetworks', data: { id } });
  }

  duplicateAffiliateNetwork() {
    this.bus.emit('open-dialog', { name: 'DuplicateAffiliateNetworks' });
  }

  createTrafficSource() {
    this.bus.emit('open-dialog', { name: 'CreateTrafficSources' });
  }

  editTrafficSource(id?: string) {
    this.bus.emit('open-dialog', { name: 'EditTrafficSource', data: { id } });
  }

  duplicateTrafficSource() {
    this.bus.emit('open-dialog', { name: 'DuplicateTrafficSource' });
  }

  fromTemplate() {
    if (this.is('traffic-sources')) {
      this.bus.emit('open-dialog', { name: 'TrafficSourceFromTemplate' });
    }

    if (this.is('affiliate-networks')) {
      this.bus.emit('open-dialog', { name: 'AffiliateNetworkFromTemplate' });
    }
  }

  importDialog() {
    const mode = this.is('landings') ? 'landings' : 'offers'
    this.bus.emit('open-dialog', { name: 'ImportDialog', data: { mode } });
  }

  getArchiveTimerPromise(timeout: number) {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve();
      }, timeout);
    });
  }

  handleModalArchiveConfirm(ids: string[]) {
    const { type } = this.$route.params;

    this.$store.commit('loading', true);

    api
      .post(`/${type}/archive`, {
        ids: ids
      })
      .then((response: Bemob.RawResponse<Bemob.ArchiveResponse>) => {
        this.billingApi.getSubscriptions()
        if(response && has(response, 'data.payload.usedItems')) {
          for(const item of response.data.payload.usedItems) {
            const usingType = this.getUsingType({type:item.usingType});
            const message = this.t('{0} is used by {1} {2}', [item.usedName, usingType, item.usingName]);

            this.bus.emit('toast-warning', message, {
              dontHide:true
            });
          }

          this.bus.emit('refresh-report');
          this.$store.commit('tableSelectedItems', null);
        } else {
          return this.getArchiveTimerPromise(1000);
        }
      })
      .then(() => {
        this.bus.emit('refresh-report');
        this.$store.commit('tableSelectedItems', null);
      })
      .finally(() => {
        this.$store.commit('loading', false);

        this.$helpers.afterBrowserRedraw(() => {
        });
      });
  }

  archive() {
    const { selectedItems } = this.$store.state.table;
    const ids = selectedItems.map((e: any) => e.DT_RowId);

    this.bus.emit('open-dialog', { name: 'ConfirmDialog', data: {
      message: this.t('All selected items will be archived if you press OK. You can restore them anytime.'),
      onConfirm: () => this.handleModalArchiveConfirm(ids),
    }})
  }

  restore() {
    const { selectedItems } = this.$store.state.table;
    const { type } = this.$route.params;

    this.$store.commit('loading', true);

    api
      .post(`/${type}/restore`, {
        ids: selectedItems.map((e: any) => e.DT_RowId)
      })
      .then(() => {
        this.billingApi.getSubscriptions()
        this.getArchiveTimerPromise(2000)
      })
      .finally(() => {
        this.bus.emit('refresh-report');
        this.$store.commit('tableSelectedItems', null);
      });
  }

  get dialogActionsEvents() {
    return {
      campaigns: {
        create: this.createCampaign,
        edit: this.editCampaign,
        duplicate: this.duplicateCampaign,
        bulkEdit: this.bulkEditCampaigns,
        updateCost: this.updateCost,
        campaignLinks: this.campaignLinks,
        startStop: this.startStop,
      },
      offers: {
        create: this.createOffer,
        edit: this.editOffer,
        duplicate: this.duplicateOffer,
        bulkEdit: this.bulkEditOffer,
      },
      landings: {
        create: this.createLanding,
        edit: this.editLanding,
        bulkEdit: this.bulkEditLanding,
        duplicate: this.duplicateLanding,
      },
      flows: {
        create: this.createFlow,
        edit: this.editFlow,
        duplicate: this.duplicateFlow,
      },
      affiliateNetworks: {
        create: this.createAffiliateNetwork,
        edit: this.editAffiliateNetwork,
        duplicate: this.duplicateAffiliateNetwork,
      },
      trafficSources: {
        create: this.createTrafficSource,
        edit: this.editTrafficSource,
        duplicate: this.duplicateTrafficSource,
      },
      common: {
        createFromTemplate: this.fromTemplate,
        archive: this.archive,
        restore: this.restore,
        import: this.importDialog
      }
    }
  }
}
